import { InputAdornment, Paper, TextField, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomInput from '../../../../components/customInput/CustomInput';
type IProps = {
  id: number | string | undefined;
  reference: string;
  sku: string;
  price: number;
  setPrice: (a: number) => void;
  setReference: (a: string) => void;
  setSku: (a: string) => void;
  setOldPrice: (a: number) => void;
  oldPrice: number;
  barcode: string;
  setBarcode: (a: string) => void;
};
function ProductIds({
  id,
  reference,
  sku,
  setReference,
  setSku,
  price,
  setPrice,
  oldPrice,
  setOldPrice,
  barcode,
  setBarcode,
}: IProps) {
  const t = useTranslate();

  return (
    <>
      <Typography variant='subtitle1'>{t('identifiers')}</Typography>
      <CustomInput
        name='id'
        defaultValue={id}
        label={t('id')}
        disabled
        style={{
          width: '100%',
        }}
      />

      <CustomInput
        defaultValue={barcode}
        label={t('barcode')}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setBarcode(e.target.value)}
      />

      <CustomInput
        defaultValue={sku}
        label={t('sku')}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setSku(e.target.value)}
      />

      <CustomInput
        defaultValue={reference}
        label={t('reference')}
        name='reference'
        style={{
          width: '100%',
        }}
        onBlur={(e) => setReference(e.target.value)}
      />
      <CustomInput
        defaultValue={price}
        name='price'
        type='number'
        label={t('price')}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setPrice(parseFloat(e.target.value))}
        unit='SEK'
      />

      <CustomInput
        defaultValue={oldPrice}
        name='oldPrice'
        label={t('oldPrice')}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setOldPrice(parseFloat(e.target.value))}
        unit='SEK'
      />
    </>
  );
}

export default ProductIds;
